import { Component, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-lock-not-found',
  templateUrl: './lock-not-found.component.html',
  styleUrls: ['./lock-not-found.component.scss'],
})
export class LockNotFoundComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;

  constructor() {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
